export const locale = {
    lang: "ca",
    data: {
        TOOLBAR: {
            Help: "Obrir manual d'usuari",
            BrowserNotificationsTitle: "Notificacions del navegador",
            BrowserNotificationsPromptBody:
                "Si continues, aquest navegador quedarà registrat per al teu usuari i rebràs notificacions del navegador d'Emma a tota l'app.",
            BrowserNotificationsEnabledBody:
                "Les notificacions del navegador ja estan activades per al teu usuari. Pots gestionar el projecte actual des d'aquí.",
            BrowserNotificationsPermissionDenied:
                "Les notificacions del navegador estan desactivades en aquest navegador. Torna-les a activar des de la configuració del lloc perquè Emma pugui enviar-te alertes aquí.",
            BrowserNotificationsCurrentProject: "Projecte actual",
            BrowserNotificationsProjectToggle: "Rebre notificacions en aquest projecte",
            BrowserNotificationsProjectStatusEnabled: "Notificacions activades en aquest projecte",
            BrowserNotificationsProjectStatusMuted: "Notificacions silenciades en aquest projecte",
            BrowserNotificationsProjectEnabled: "Notificacions del navegador activades per a aquest projecte.",
            BrowserNotificationsProjectMuted: "Notificacions del navegador silenciades per a aquest projecte.",
            BrowserNotificationsEnableAction: "Activar notificacions",
            BrowserNotificationsSkip: "Ara no",
            BrowserNotificationsNotConfigured: "Les notificacions del navegador no estan configurades en aquest entorn.",
            BrowserNotificationsUnsupported: "Aquest navegador no admet notificacions push.",
            BrowserNotificationsEnabled: "Notificacions del navegador activades.",
            BrowserNotificationsError: "No s'ha pogut actualitzar la preferència de notificacions del navegador.",
            BrowserNotificationHeadlineAlarm: "Alarma crítica",
            BrowserNotificationHeadlineWarning: "Alarma d'avís",
            BrowserNotificationHeadlineSuccess: "Alarma desactivada",
            BrowserNotificationHeadlineInfo: "Notificació",
            BrowserNotificationFieldAlarm: "Alarma",
            BrowserNotificationFieldProject: "Projecte",
            BrowserNotificationFieldDevice: "Dispositiu",
        },
    },
};
